import useLoggedInUser from '@/composables/logged-in-user/logged-in-user';
import useProperties from '@/composables/property/property';
import { iconByType } from '@/lib/property';
import { textByLang } from 'shared/lib/language';
import { useI18n } from 'vue-i18n';

export default function useSorterOptions() {
  const { userLang } = useLoggedInUser();
  const { properties } = useProperties();
  const { t } = useI18n();

  const optionIcon = (order) => {
    if (typeof order.langs !== 'undefined' && order.langs.length === 1) {
      const property = properties.value.find((p) => p.uid === parseInt(order.langs[0].slice(1), 10));
      if (typeof property !== 'undefined') {
        return iconByType({ type: property.type });
      }
    }

    return iconByType({ edgeName: order.attr });
  };

  const optionLabel = (order) => {
    if (typeof order.langs !== 'undefined' && order.langs.length === 1) {
      const property = properties.value.find((p) => p.uid === parseInt(order.langs[0].slice(1), 10));
      if (typeof property !== 'undefined') {
        return textByLang(property.label, userLang.value);
      }
    }

    return t(`edges.${order.attr}`);
  };

  return {
    optionIcon,
    optionLabel,
  };
}
